export const PENDING_INVITATION_KEY = 'pendingInvitation';

export function capturePendingInvitationFromUrl(
  search: string = typeof window !== 'undefined' ? window.location.search : ''
): void {
  if (typeof window === 'undefined') {
    return;
  }
  const code = new URLSearchParams(search).get('invite')?.trim();
  if (code) {
    window.localStorage.setItem(PENDING_INVITATION_KEY, code);
  }
}

export function getPendingInvitationCode(): string {
  if (typeof window === 'undefined') {
    return '';
  }
  const urlInvite = new URLSearchParams(window.location.search).get('invite')?.trim();
  const storedInvite = window.localStorage.getItem(PENDING_INVITATION_KEY)?.trim();
  return urlInvite || storedInvite || '';
}

/** Drop stored and URL invite params so a failed or stale invite is not retried every load. */
export function clearPendingInvitation(): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.removeItem(PENDING_INVITATION_KEY);
  const url = new URL(window.location.href);
  if (!url.searchParams.has('invite')) {
    return;
  }
  url.searchParams.delete('invite');
  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
}
